const TEAM_TYPE_LABELS = {
  scrum: 'Scrum',
  kanban: 'Kanban',
  safe: 'SAFe',
  less: 'LeSS',
  xp: 'XP',
  agile: 'Agile',
};

const TEAM_TOOL_LABELS = {
  jira: 'Jira',
  'azure-devops': 'Azure DevOps',
  'azure devops': 'Azure DevOps',
  'agility (versionone)': 'Agility (VersionOne)',
  'version-one': 'Agility (VersionOne)',
  rally: 'Rally',
};

export class TeamsService {
  constructor({ teamsGateway } = {}) {
    this.teamsGateway = teamsGateway || null;
  }

  async listTeams() {
    if (!this.teamsGateway || typeof this.teamsGateway.list !== 'function') {
      return [];
    }
    const startedAt = Date.now();
    try {
      const result = await this.teamsGateway.list();
      this.#recordTelemetry({ action: 'list', outcome: 'success', startedAt });
      return result;
    } catch (error) {
      this.#recordTelemetry({ action: 'list', outcome: 'error', startedAt, error });
      throw error;
    }
  }

  async createTeam(teamData = {}) {
    const name = typeof teamData.name === 'string' ? teamData.name.trim() : teamData.name;
    if (!name) {
      throw new Error('Team name is required');
    }
    if (!this.teamsGateway || typeof this.teamsGateway.create !== 'function') {
      throw new Error('Teams gateway unavailable');
    }

    const payload = {
      ...teamData,
      name,
    };

    if (payload.type) {
      payload.type = normalizeTeamType(payload.type);
    }

    if (payload.tool) {
      payload.tool = normalizeTeamTool(payload.tool);
    }
    const startedAt = Date.now();
    try {
      const result = await this.teamsGateway.create(payload);
      this.#recordTelemetry({ action: 'create', outcome: 'success', startedAt });
      return result;
    } catch (error) {
      this.#recordTelemetry({ action: 'create', outcome: 'error', startedAt, error });
      throw error;
    }
  }

  async uploadTeamLogo(teamId, file) {
    if (!teamId) {
      throw new Error('Team ID is required');
    }
    if (!this.teamsGateway || typeof this.teamsGateway.uploadLogo !== 'function') {
      throw new Error('Teams gateway unavailable');
    }
    const startedAt = Date.now();
    try {
      const result = await this.teamsGateway.uploadLogo(teamId, file);
      this.#recordTelemetry({ action: 'uploadLogo', outcome: 'success', startedAt });
      return result;
    } catch (error) {
      this.#recordTelemetry({ action: 'uploadLogo', outcome: 'error', startedAt, error });
      throw error;
    }
  }


  #recordTelemetry({ action, outcome, startedAt, error = null }) {
    if (typeof window === 'undefined') {
      return;
    }
    const debug = window.Debug || null;
    if (!debug || typeof debug.recordTeamsTelemetry !== 'function') {
      return;
    }
    const durationMs = typeof startedAt === 'number' ? Date.now() - startedAt : undefined;
    debug.recordTeamsTelemetry({
      action,
      outcome,
      durationMs,
      errorMessage: error && error.message ? error.message : error ? String(error) : undefined,
    });
  }
}

function normalizeTeamType(value) {
  if (typeof value !== 'string') {
    return value;
  }
  const key = value.trim();
  if (!key) {
    return key;
  }
  const mapped = TEAM_TYPE_LABELS[key.toLowerCase()];
  if (mapped) {
    return mapped;
  }
  // Allow already-capitalised values to pass through
  if (TEAM_TYPE_LABELS[key]) {
    return TEAM_TYPE_LABELS[key];
  }
  return key;
}

function normalizeTeamTool(value) {
  if (typeof value !== 'string') {
    return value;
  }
  const key = value.trim();
  if (!key) {
    return key;
  }
  const lower = key.toLowerCase();
  if (Object.prototype.hasOwnProperty.call(TEAM_TOOL_LABELS, lower)) {
    return TEAM_TOOL_LABELS[lower];
  }
  if (Object.prototype.hasOwnProperty.call(TEAM_TOOL_LABELS, key)) {
    return TEAM_TOOL_LABELS[key];
  }
  return key;
}

if (typeof window !== 'undefined') {
  window.AgileProServices = window.AgileProServices || {};
  window.AgileProServices.TeamsService = TeamsService;
}
